<template>
  <div class="b-pop-up--otp__resend">
    <Alert
      v-if="!isLoading && sendCounter"
      key="submit-errors"
      type="info"
      :messages="[dictionary.infoResent]"
      :dismissible="false"></Alert>

    <Alert
      v-if="!isLoading && errorMsgs.length"
      key="submit-errors"
      type="danger"
      :messages="errorMsgs"
      dismiss-by-native=""
      @close="removeErrors"></Alert>

    <div class="b-pop-up--otp__resend__bottom">
      <div class="b-pop-up--otp__resend__title">
        {{ dictionary.infoNotReceived }}
      </div>
      <button v-if="allowResend" type="button" class="b-pop-up--otp__resend__cta" @click="resend">
        {{ dictionary.ctaResendText }}
      </button>
      <div v-if="inTime" class="b-pop-up--otp__resend__timer">
        {{ countDownTime }}
      </div>
    </div>
  </div>
</template>

<script>
import Alert from './../Shared/Alert.vue'

export default {
  components: { Alert },
  props: {
    dictionary: {
      default() {
        return {}
      },
      type: Object,
    },
    handler: {
      default: '',
      type: String,
    },
    email: {
      default: '',
      type: String,
    },
    maxResends: {
      default: 5,
      type: Number,
    },
    timeOut: {
      type: Number,
      default: 100000,
    },
  },
  emits: ['loading', 'success', 'failed', 'resend'],
  data() {
    return {
      errorMsgs: [],
      isLoading: false,
      isOpened: false,
      code: '',
      sendCounter: 0,
      inTime: true,
      count: 0,
    }
  },
  computed: {
    allowResend() {
      return !this.inTime && this.sendCounter < this.maxResends
    },
    totalTime() {
      return this.timeOut / 1000
    },
    countDownTime() {
      return `${Math.abs(this.totalTime - this.count)}”`
    },
  },
  mounted(){
    this.startTimer()
  },
  methods: {
    async resend() {
      this.sendCounter = this.sendCounter + 1
      this.startTimer()
      this.$emit("resend", this.sendCounter)      
    },
    
    removeErrors() {
      this.errorMsgs = []
    },
    startTimer() {
      this.inTime = true
      this.count = 0
      clearInterval(this.timer)

      this.timer = setInterval(() => {
        this.count = this.count + 1

        if (this.count >= this.totalTime) {
          this.inTime = false
          clearInterval(this.timer)
        }
      }, 1000)
    },
  },
}
</script>
